import { render, staticRenderFns } from "./CorporateDirectoryViewMore.vue?vue&type=template&id=3f0053ac&scoped=true"
import script from "./CorporateDirectoryViewMore.vue?vue&type=script&lang=js"
export * from "./CorporateDirectoryViewMore.vue?vue&type=script&lang=js"
import style0 from "./CorporateDirectoryViewMore.vue?vue&type=style&index=0&id=3f0053ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0053ac",
  null
  
)

export default component.exports